// List of all incident types for selects and validation, organized into groups
export const INCIDENT_TYPE_GROUPS = [
  {
    label: 'Motor Vehicles',
    options: [
      { value: 'car-collision', label: 'Car Collision (Car vs Car)' },
      { value: 'multiple-vehicle-incident', label: 'Multiple Vehicle Incident' },
      { value: 'car-pedestrian', label: 'Car vs Pedestrian' },
      { value: 'car-bicycle', label: 'Car vs Bicycle' },
      { value: 'car-motorcycle', label: 'Car vs Motorcycle' },
      { value: 'car-animal', label: 'Car vs Animal' },
      { value: 'car-property', label: 'Car vs Property' },
      { value: 'car-rollover', label: 'Car Rollover' },
      { value: 'car-fire', label: 'Car Fire' },
    ],
  },
  {
    label: 'Motorcycles',
    options: [
      { value: 'motorcycle-collision', label: 'Motorcycle Collision' },
      { value: 'motorcycle-car', label: 'Motorcycle vs Car' },
      { value: 'motorcycle-pedestrian', label: 'Motorcycle vs Pedestrian' },
      { value: 'motorcycle-bicycle', label: 'Motorcycle vs Bicycle' },
      { value: 'motorcycle-animal', label: 'Motorcycle vs Animal' },
      { value: 'motorcycle-property', label: 'Motorcycle vs Property' },
      { value: 'motorcycle-single', label: 'Single Motorcycle Accident' },
    ],
  },
  {
    label: 'Trucks',
    options: [
      { value: 'truck-collision', label: 'Truck Collision' },
      { value: 'truck-car', label: 'Truck vs Car' },
      { value: 'truck-motorcycle', label: 'Truck vs Motorcycle' },
      { value: 'truck-bicycle', label: 'Truck vs Bicycle' },
      { value: 'truck-pedestrian', label: 'Truck vs Pedestrian' },
      { value: 'truck-animal', label: 'Truck vs Animal' },
      { value: 'truck-property', label: 'Truck vs Property' },
      { value: 'truck-rollover', label: 'Truck Rollover' },
      { value: 'truck-load-spill', label: 'Truck Load Spill' },
    ],
  },
  {
    label: 'Bicycles',
    options: [
      { value: 'bicycle-collision', label: 'Bicycle Collision' },
      { value: 'bicycle-car', label: 'Bicycle vs Car' },
      { value: 'bicycle-motorcycle', label: 'Bicycle vs Motorcycle' },
      { value: 'bicycle-truck', label: 'Bicycle vs Truck' },
      { value: 'bicycle-pedestrian', label: 'Bicycle vs Pedestrian' },
      { value: 'bicycle-animal', label: 'Bicycle vs Animal' },
      { value: 'bicycle-property', label: 'Bicycle vs Property' },
      { value: 'bicycle-single', label: 'Single Bicycle Accident' },
    ],
  },
  {
    label: 'Electric Scooters',
    options: [
      { value: 'scooter-collision', label: 'Electric Scooter Collision' },
      { value: 'scooter-car', label: 'Electric Scooter vs Car' },
      { value: 'scooter-motorcycle', label: 'Electric Scooter vs Motorcycle' },
      { value: 'scooter-truck', label: 'Electric Scooter vs Truck' },
      { value: 'scooter-bicycle', label: 'Electric Scooter vs Bicycle' },
      { value: 'scooter-pedestrian', label: 'Electric Scooter vs Pedestrian' },
      { value: 'scooter-animal', label: 'Electric Scooter vs Animal' },
      { value: 'scooter-property', label: 'Electric Scooter vs Property' },
      { value: 'scooter-single', label: 'Single Electric Scooter Accident' },
    ],
  },
  {
    label: 'Pedestrians',
    options: [
      { value: 'pedestrian-car', label: 'Pedestrian vs Car' },
      { value: 'pedestrian-motorcycle', label: 'Pedestrian vs Motorcycle' },
      { value: 'pedestrian-truck', label: 'Pedestrian vs Truck' },
      { value: 'pedestrian-bicycle', label: 'Pedestrian vs Bicycle' },
      { value: 'pedestrian-animal', label: 'Pedestrian vs Animal' },
      { value: 'pedestrian-fall', label: 'Pedestrian Fall/Slip' },
      { value: 'pedestrian-property', label: 'Pedestrian vs Property' },
    ],
  },
  {
    label: 'Animals',
    options: [
      { value: 'animal-car', label: 'Animal vs Car' },
      { value: 'animal-motorcycle', label: 'Animal vs Motorcycle' },
      { value: 'animal-truck', label: 'Animal vs Truck' },
      { value: 'animal-bicycle', label: 'Animal vs Bicycle' },
      { value: 'animal-pedestrian', label: 'Animal vs Pedestrian' },
      { value: 'animal-loose', label: 'Loose Animal' },
    ],
  },
  {
    label: 'Near Misses & Dangerous Driving',
    options: [
      { value: 'near-miss-car', label: 'Near Miss - Car' },
      { value: 'near-miss-motorcycle', label: 'Near Miss - Motorcycle' },
      { value: 'near-miss-truck', label: 'Near Miss - Truck' },
      { value: 'near-miss-bicycle', label: 'Near Miss - Bicycle' },
      { value: 'near-miss-pedestrian', label: 'Near Miss - Pedestrian' },
      { value: 'dangerous-driving-car', label: 'Dangerous Driving - Car' },
      { value: 'dangerous-driving-motorcycle', label: 'Dangerous Driving - Motorcycle' },
      { value: 'dangerous-driving-truck', label: 'Dangerous Driving - Truck' },
      { value: 'dangerous-driving-bicycle', label: 'Dangerous Driving - Bicycle' },
      { value: 'road-rage', label: 'Road Rage Incident' },
      { value: 'speeding', label: 'Excessive Speeding' },
      { value: 'reckless-driving', label: 'Reckless Driving' },
    ],
  },
  {
    label: 'Road & Traffic Hazards',
    options: [
      { value: 'traffic-light-malfunction', label: 'Traffic-light Malfunction' },
      { value: 'traffic-light-damage', label: 'Traffic-light Damage' },
      { value: 'road-hazard', label: 'Road Hazard' },
      { value: 'debris-on-road', label: 'Debris on Road' },
      { value: 'pothole-or-surface-damage', label: 'Pothole or Surface Damage' },
      { value: 'signage-issue', label: 'Signage Issue' },
      { value: 'roadwork-issue', label: 'Roadwork Issue' },
      { value: 'traffic-congestion-or-gridlock', label: 'Traffic Congestion/Gridlock' },
      { value: 'other-traffic-hazard', label: 'Other Traffic Hazard' },
    ],
  },
  {
    label: 'Other',
    options: [
      { value: 'property-damage', label: 'Property Damage Only' },
      { value: 'fire', label: 'Fire Incident' },
      { value: 'flooding', label: 'Flooding/Water Damage' },
      { value: 'debris', label: 'Debris on Road' },
      { value: 'traffic-light', label: 'Traffic Light Malfunction (Legacy)' },
      { value: 'other', label: 'Other/Unspecified' },
    ],
  },
];

// Flat list for legacy usage
const INCIDENT_TYPES = INCIDENT_TYPE_GROUPS.flatMap(g => g.options);
export default INCIDENT_TYPES;
